// @flow
import { int, nullableInt, double, nullableDouble } from "../helpers/types";
import type { numberDouble } from "../helpers/types";

export type AuctionLot = {
  id: number,
  cat: ?number,
  barcode: number,
  title: string,
  description: string,
  image: ?string,
  categories: Array<number>,
  location: ?string,
  status: string,
  weight: number,
  start: ?Date,
  stop: ?Date,
  startingBid: numberDouble,
  nextBid: numberDouble,
  highestBid: ?numberDouble,
  highestBidId: ?number,
  buyer: ?number,
  highestBidder: ?number,
  seller: ?number,
  percentageFee: numberDouble,
  additionalFee: numberDouble,

  estimateLow: numberDouble,
  estimateHigh: numberDouble,

  aftersales: boolean
};

export type AuctionLotsApiItemCategory = {
  cat_id: string,
  cat_sort_order: string
};
export type AuctionLotsApiItem = {
  alo_id: string,
  alo_number: ?string,
  alo_range_minimum: string,
  alo_range_maximum: string,
  alo_start_online_bidding_datetime: ?string,
  alo_end_online_bidding_datetime: ?string,
  alo_starting_bid: string,
  alo_aftersales: boolean,
  alo_buyer_usr_id: ?string,
  alo_percentage_agio: string,
  alo_buyer_administration_costs: string,
  obj_barcode: string,
  obj_short_description: string,
  obj_description: string,
  obj_key_image_fil_path: ?string,
  alo_auc_id: string,
  alo_seller_usr_id: ?string,
  alo_status:
    | "AFTERSALES"
    | "APPRAISED"
    | "DELETED"
    | "DISCARD"
    | "EXPORTED"
    | "LIVE_BIDDING"
    | "MOVED_TO_AUCTION"
    | "MOVED_TO_WEBSHOP"
    | "NEW"
    | "ONLINE_BIDDING"
    | "OUT_OF_STOCK"
    | "PAUSED"
    | "REGISTRATION"
    | "REJECTED"
    | "RETURNED"
    | "SOLD"
    | "SOLD_EXTERNALLY"
    | "UNSOLD"
    | "WEBSHOP",
  alo_highest_bid_id: ?string,
  alo_highest_bid_usr_id: ?string,
  alo_highest_bid_amount: ?string,
  alo_minimum_bid_amount: string,
  alo_status_order: string,
  categories: Array<AuctionLotsApiItemCategory>,
  storage: {
    sto_id: string,
    sto_token: ?string,
    sto_description: string
  }
};

export default function modelAuctionLot(item: AuctionLotsApiItem): AuctionLot {
  return {
    id: int(item.alo_id),
    cat: nullableInt(item.alo_number),
    barcode: int(item.obj_barcode),
    title: item.obj_short_description,
    description: item.obj_description,
    image: item.obj_key_image_fil_path,
    categories: (item.categories || []).map(i => int(i.cat_id)),
    location: item.storage ? item.storage.sto_description : "",

    status: item.alo_status,
    weight: int(item.alo_status_order),

    start: item.alo_start_online_bidding_datetime
      ? new Date(item.alo_start_online_bidding_datetime)
      : null,
    stop: item.alo_end_online_bidding_datetime
      ? new Date(item.alo_end_online_bidding_datetime)
      : null,

    startingBid: double(item.alo_starting_bid),
    nextBid: double(item.alo_minimum_bid_amount),

    highestBid: nullableDouble(item.alo_highest_bid_amount),
    highestBidId: nullableInt(item.alo_highest_bid_id),

    buyer: nullableInt(item.alo_buyer_usr_id),
    highestBidder: nullableInt(item.alo_highest_bid_usr_id),
    seller: nullableInt(item.alo_seller_usr_id),

    percentageFee: double(item.alo_percentage_agio),
    additionalFee: double(item.alo_buyer_administration_costs),

    estimateLow: double(item.alo_range_minimum),
    estimateHigh: double(item.alo_range_maximum),

    aftersales: item.alo_aftersales
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/auctionLot.js